import React, { useState } from "react";
import { locale } from "../../../translate/sweden";
import "./BookingNotes.scss";

const BookingNotes = (props) => {
  const [notes, setNotes] = useState(props.value);

  const handleChange = (val) => {
    setNotes(val);
  };

  return (
    <div className="BookingNotes">
      <p>{locale.lastBookingStep.addBookingNotesDescription}</p>
      <textarea
        placeholder={locale.lastBookingStep.addBookingNotesPlaceholder}
        value={notes}
        onChange={(e) => handleChange(e.target.value)}
      />
      <div
        className="termsBottom"
        onClick={() => {
          props.onSave();
          props.onChange(notes);
        }}
      >
        <button>{locale.lastBookingStep.save}</button>
      </div>
    </div>
  );
};

export default BookingNotes;
